import React from "react";
import { P_Props } from "./Pulse.type";

const PulsePresenter: React.FC<P_Props> = (props) => {
  return <div className={`pulse ${props.color}`}>{props.children}</div>;
};

export default PulsePresenter;
